/* eslint-disable react/prop-types */
import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';
const {CBTable} = window.cb.apricot;

import spaceRemoval from '../../constants/removeSpace';
import './Table.scss';

const Table = ({heads, bodyData}) => {
  useEffect(() => {
    document.querySelectorAll('.cb-table-responsive').forEach(elem => {
      CBTable.customScrollbar({
        elem
      });
    });
  });
  const dat = bodyData;
  const TableHeaders = ({headers}) => (
    <thead>
      <tr>
        {headers?.map(head => <th scope='col' id={spaceRemoval(head)} key={head}>{head}</th>)}
      </tr>
    </thead>
  );
  const TableRow = ({row}) => {
    const editId = row[0].split('/')[1];
    return(
      <tr>
        {row?.map((cell, index) => (index===0)?<th id={spaceRemoval(cell.split('/')[0])} scope='row' key={index}>{cell.split('/')[0]}</th>:<td key={index}>{cell.split('/')[0]}</td>)}
        <td>
        <nav style={{width: "100%"}}>
            <Link to={`/categories/${editId}`} className='btnedit' id={`btn_${row[0]}`}>
              <p>show</p>
            </Link>
          </nav>
        </td>
      </tr>
    );
  };
  return(
    <div className='cb-scrollbar-container'>
      <div className='cb-scrollbar cb-top'>
        <div className='cb-scrollbar-thumb' />
      </div>
      <div className='cb-table-responsive'>
        <table className='cb-table cb-table-condensed cb-table-striped-reverse'>
          <caption>Campaign Status</caption>
          <TableHeaders headers={heads} />
          <tbody>
            {
          dat?.map((row, index) => (<TableRow key={index} row={Object.values(row)} />))
            }
          </tbody>
        </table>
      </div>
      <div className='cb-scrollbar cb-bottom'>
        <div className='cb-scrollbar-thumb' />
      </div>
    </div>
  );
};

export default Table;